export const urlRegex =
	'^(https?://)([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$';
export const colorRegex = '^#(?:[0-9a-fA-F]{3}){1,2}$';
export const alphaNumRegex = '^([a-zA-Z0-9_]*)?$';
